import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CurrentUserService } from '@rma/dashboard/authentication/public/user';
import { LoginPathsService } from '@rma/dashboard/authentication/public/util-login-paths';
import { filter } from 'rxjs';

/**
 * @deprecated This functionality will be replaced by guards.
 *
 * LEGACY CLEANUP
 */
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class LoginRedirectService {
  constructor(
    private readonly currentUserService: CurrentUserService,
    private readonly loginPathService: LoginPathsService,
  ) {}

  public redirectIfUnauthenticated() {
    this.currentUserService.isAuthenticated$
      .pipe(
        filter((isAuthenticated) => !isAuthenticated),
        untilDestroyed(this),
      )
      .subscribe(() => this.loginPathService.goToClaim());
  }
}
